































































































































import BaseComponent from '@/components/base-component.vue';
import InstitutionFilters from '@/components/crm/institution/institution-filters.vue';
import InstitutionForm from '@/components/crm/institution/institution-form.vue';
import UiAutocompleClientsSubsidiaries from '@/components/UI/autocomplete-clients-subsidiaries.vue';
import UiDatePicker from '@/components/UI/date-picker.vue';
import UiFilterContainer from '@/components/UI/filter-container.vue';
import ListMessages from '@/components/UI/list-messages.vue';
import UiBtnTableInfosUserAlter from '@/components/UI/btn-table-infos-user-alter.vue';
import PermissionAuth from '@/components/UI/permission-auth.vue';
import UiTableContainer from '@/components/UI/table-container.vue';
import UiToggleStatus from '@/components/UI/toggle-status.vue';
import { PaginationSyncDTO, ResultPagDTO } from '@/interfaces/base-dto';
import { InstituicaoFiltrosDTO } from '@/interfaces/crm-institution';
import { deleteInstitution, listInstitutionsByFilters, updateActivationInstitution } from '@/services/crm-institution';
import Component from 'vue-class-component';
import { Watch } from 'vue-property-decorator';

@Component({
  components: {
    PermissionAuth,
    ListMessages,
    UiDatePicker,
    UiAutocompleClientsSubsidiaries,
    InstitutionForm,
    UiFilterContainer,
    InstitutionFilters,
    UiTableContainer,
    UiToggleStatus,
    UiBtnTableInfosUserAlter
  }
})
export default class Institution extends BaseComponent {
  public formIsEdit: boolean = false;
  public formOpen: boolean = false;
  public edit: boolean = false;

  idSelected = null;
  filter: any = {};

  items = [];
  pagination: PaginationSyncDTO = new PaginationSyncDTO();
  pagina: ResultPagDTO<any> = new ResultPagDTO();
  loading = false;
  error = false;

  filterReloadCount = 1;

  public headers: any = [
    { text: 'C/P', value: 'dsSituacao', sortable: true },
    { text: 'Área', value: 'cdAreaGeografica', sortable: true, align: 'center' },
    { text: 'CNPJ', value: 'cnpj', sortable: true },
    { text: 'Nome Fantasia', value: 'nomeFantasia', sortable: true },
    { text: 'Status', value: 'status', sortable: true, align: 'center' },
    { text: 'Dias sem visita', value: 'diasSemVisitaOrdenar', sortable: true, align: 'center' },
    { text: 'Ultima visita', value: 'ultimaVisita', sortable: true, align: 'center' },
    { text: 'Próxima visita', value: 'proximaVisita', sortable: true, align: 'center' },
    { text: '', value: '', sortable: false, width: '30' }
  ];

  mounted() {
    this.load();
  }

  newItem() {
    this.idSelected = null;
    this.formOpen = true;
    this.edit = true;
  }

  openItem(item, edit) {
    this.idSelected = item.id;
    this.formOpen = true;
    this.edit = edit;
  }

  onCloseForm() {
    this.formOpen = false;
  }

  onAfterSave() {
    this.formOpen = false;
    this.load();
    this.filterReloadCount++;
  }

  public onFilter(value): void {
    this.filter = value;
    this.pagination.page = 1;
    if (this.filter.sortBy) {
      this.pagination.descending = this.filter.descending;
      this.pagination.sortBy = this.filter.sortBy;
    }
    this.load();
  }

  onChangeFilter() {
    this.load();
  }

  load() {
    this.items = [];
    this.loading = true;
    this.error = false;

    let filters = Object.assign(new InstituicaoFiltrosDTO(), this.filter);
    filters.update(this.pagination);
    listInstitutionsByFilters(filters).subscribe(
      (result) => {
        this.items = result.content;
        this.loading = false;
        this.pagina = result;
        PaginationSyncDTO.update(this.pagination, result);
      },
      (error) => {
        this.loading = false;
        this.error = true;
        this.showToastApiError(error);
      }
    );
  }

  onItemActivationChange(item, status) {
    this.loader.start('Processando ...');
    updateActivationInstitution(item.id, status).subscribe(
      (res) => {
        this.loader.stop();
        this.toast.show(`Instituição ${status ? 'ativada' : 'desativada'} com sucesso`, 'success');
        this.load();
      },
      (error) => {
        this.loader.stop();
        this.showToastApiError(error);
      }
    );
  }

  @Watch('pagination.page')
  @Watch('pagination.rowsPerPage')
  @Watch('pagination.sortBy')
  @Watch('pagination.descending')
  private onChangePagination() {
    this.load();
  }

  public deleteItem(item): void {
    const deleteAction = () => {
      this.loader.start('Processando... ');
      deleteInstitution(item.id).subscribe(
        (res) => {
          this.loader.stop();
          this.toast.show('Instituição excluída com sucesso', 'success');
          this.load();
        },
        (error) => {
          this.loader.stop();
          this.showToastApiError(error);
        }
      );
    };

    this.dialog.show(
      'error',
      'Exclusão de instituição',
      `Deseja excluir a instituição ${item.nomeFantasia}?`,
      'Voltar',
      '',
      'Excluir',
      deleteAction
    );
  }
}
